import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

/**
 * Anexa o access token do Cognito às chamadas para a API da plataforma
 * (`environment.apiUrl`). Não toca em assets, Cognito ou outras origens.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.apiUrl;
  if (!apiUrl || !req.url.startsWith(apiUrl)) {
    return next(req);
  }

  const auth = inject(AuthService);
  return from(auth.accessToken()).pipe(
    switchMap((token) =>
      next(token ? req.clone({ setHeaders: { Authorization: token } }) : req),
    ),
  );
};
